import React from 'react';
import { getComponentClasses } from '@99designs/frontend-components/utils/app/index';

export interface Props {
    quote: string | React.ReactNode;
    variations?: string[];
}

function Blockquote({ quote, variations = [] }: Props) {
    return (
        <blockquote className={getComponentClasses('blockquote', variations)}>
            <div className="blockquote__quote">{quote}</div>
        </blockquote>
    );
}

export default Blockquote;
